const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

function normalizeUrlLike(value: string): string {
  if (value === "/") {
    return value;
  }

  return value.endsWith("/") ? value.slice(0, -1) : value;
}

function readEnvValue(value: string | undefined): string | undefined {
  const normalized = value?.trim();
  if (!normalized) {
    return undefined;
  }

  return normalizeUrlLike(normalized);
}

function joinPath(base: string, path: string): string {
  const normalizedBase = normalizeUrlLike(base);
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export const APP_URL =
  readEnvValue(import.meta.env.VITE_APP_URL) ||
  (typeof window !== "undefined" ? normalizeUrlLike(window.location.origin) : "");

export const API_BASE_URL = readEnvValue(import.meta.env.VITE_API_URL) || "/api";

export function resolveApiPublicUrl(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (ABSOLUTE_URL_PATTERN.test(API_BASE_URL)) {
    return joinPath(API_BASE_URL, normalizedPath);
  }

  if (typeof window !== "undefined") {
    return new URL(joinPath(API_BASE_URL, normalizedPath), window.location.origin).toString();
  }

  return joinPath(API_BASE_URL, normalizedPath);
}

export const API_HEALTHCHECK_URL = resolveApiPublicUrl("/health/version");
